import type { SpatialExtent } from '../../data/model';

export interface PlaceResult {
  readonly label: string;
  readonly longitude: number;
  readonly latitude: number;
  readonly extent: SpatialExtent | null;
}

export function geoapifyAutocompleteUrl(
  query: string,
  key: string,
  center: readonly [number, number],
): string {
  const url = new URL('https://api.geoapify.com/v1/geocode/autocomplete');
  url.searchParams.set('text', query.trim());
  url.searchParams.set('format', 'json');
  url.searchParams.set('limit', '8');
  url.searchParams.set('bias', `proximity:${center[0]},${center[1]}`);
  url.searchParams.set('apiKey', key);
  return url.toString();
}

export function parseGeoapifyPlaces(data: unknown): PlaceResult[] {
  if (!data || typeof data !== 'object' || !('results' in data) || !Array.isArray(data.results))
    return [];
  const places: PlaceResult[] = [];
  for (const value of data.results.slice(0, 8) as unknown[]) {
    if (!value || typeof value !== 'object') continue;
    const item = value as Record<string, unknown>;
    if (
      typeof item.formatted !== 'string' ||
      typeof item.lon !== 'number' ||
      typeof item.lat !== 'number' ||
      !Number.isFinite(item.lon) ||
      !Number.isFinite(item.lat)
    )
      continue;
    const box = item.bbox as Record<string, unknown> | undefined;
    const extent =
      box && ['lon1', 'lat1', 'lon2', 'lat2'].every((key) => typeof box[key] === 'number')
        ? {
            west: box.lon1 as number,
            south: box.lat1 as number,
            east: box.lon2 as number,
            north: box.lat2 as number,
            crossesAntimeridian: false,
          }
        : null;
    places.push({ label: item.formatted, longitude: item.lon, latitude: item.lat, extent });
  }
  return places;
}
